import React, { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
import authApi from "../api/authentication";
import Swal from "sweetalert2";

const LoginPage = ({ setAccessToken }) => {
  const buttonRef = useRef(null);

  const [emailOrUsername, setEmailOrUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleUsernameChange = (event) => {
    setEmailOrUsername(event.target.value);
  };

  const handlePassowrdChange = (event) => {
    setPassword(event.target.value);
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });

  const submitLogin = async () => {
    try {
      const response = await authApi.dashboardlogin(emailOrUsername, password);

      if (response.status == 200 && response.data.Success) {
        setAccessToken(response.data.Token);
        Cookies.set("accesstoken", response.data.Token, { expires: 1 });
        Toast.fire({
          icon: "success",
          title: "Login Successful!",
        });
      } else {
        setAccessToken("");
        document.cookie = `accesstoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        Toast.fire({
          icon: "error",
          title:
            response.data.Message == "Admin.App.Account.Login.WrongCredentials"
              ? "Invalid Credentials!"
              : response.data.Message,
        });
      }

      //console.log(response);
    } catch (er) {
      console.log(er);
    }
  };

  const handleGlobalKeyDown = (event) => {
    if (event.key === "Enter") {
      buttonRef.current?.click(); // Safe click if ref is set
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleGlobalKeyDown);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleGlobalKeyDown);
    };
  }, []);

  return (
    <div className="container d-flex align-items-center justify-content-center min-vh-100">
      <div className="card p-4" style={{ width: "100%", maxWidth: "400px" }}>
        <div
          className="card p-4"
          style={{
            textAlign: "center",
            backgroundColor: "#2c786c",
            width: "400px",
            padding: "10px",
            alignSelf: "center",
            marginTop: "-50px",
            borderRadius: "0.375rem 0.375rem 0rem 0rem",
          }}
        >
          <img
            src="https://nn.drife.dev/css/admin/assets/media/logos/navigate-north-logo.png"
            alt=""
            width={200}
            style={{ alignSelf: "center" }}
          />
        </div>
        <div className="card-body">
          <h3 className="card-title text-left mb-4">Login</h3>
          <form>
            <div className="mb-3">
              <label htmlFor="emailOrUsername" className="form-label">
                Email or Username
              </label>
              <input
                type="text"
                className="form-control"
                id="emailOrUsername"
                placeholder="Enter your email or username"
                value={emailOrUsername}
                onChange={handleUsernameChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={handlePassowrdChange}
              />
            </div>
            <div className="d-grid">
              <button
                type="button"
                className="btn"
                style={{ backgroundColor: "#2c786c", color: "white" }}
                onClick={submitLogin}
                ref={buttonRef}
              >
                Login
              </button>
            </div>
            {/* <div className="text-center mt-3">
              <a href="/passwordrecovery" className="text-muted">
                Forgot password?
              </a>
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
